<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('product View');
  },
}
</script>

<style scoped>

</style>
